import { render, staticRenderFns } from "./shopSelectConfig.vue?vue&type=template&id=30b5dfa5&scoped=true"
import script from "./shopSelectConfig.vue?vue&type=script&lang=js"
export * from "./shopSelectConfig.vue?vue&type=script&lang=js"
import style0 from "./shopSelectConfig.vue?vue&type=style&index=0&id=30b5dfa5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b5dfa5",
  null
  
)

export default component.exports